import LogicSetEvaluationBanner from './LogicSetEvaluationBanner'

export default LogicSetEvaluationBanner
